import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import { useLanguage } from "@/context/LanguageContext";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import NeedsMatrix from "@/components/NeedsMatrix";
import ModularGrowth from "@/components/ModularGrowth";
import Process from "@/components/Process";
import ClosingCta from "@/components/ClosingCta";
import Footer from "@/components/Footer";
import QuoteModal from "@/components/QuoteModal";
import WhatsAppButton from "@/components/WhatsAppButton";

const BootScreen = () => {
  const { t } = useLanguage();
  return (
    <motion.div
      key="boot"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-4 bg-ink"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      data-testid="boot-screen"
    >
      <motion.p
        initial={{ opacity: 0, letterSpacing: "0.6em" }}
        animate={{ opacity: 1, letterSpacing: "0.3em" }}
        transition={{ duration: 0.9 }}
        className="font-display text-xl font-extrabold tracking-[0.3em] text-slate-100 sm:text-2xl"
      >
        {t.boot[0]}
      </motion.p>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 1, 0.4, 1] }}
        transition={{ duration: 1.2 }}
        className="font-mono text-xs tracking-[0.25em] text-cy"
      >
        {t.boot[1]}
      </motion.p>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.3, ease: "easeInOut" }}
        className="h-px w-48 origin-left bg-gradient-to-r from-cy to-em"
      />
    </motion.div>
  );
};

export default function Landing() {
  const [booted, setBooted] = useState(false);
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const timer = setTimeout(() => setBooted(true), 1700);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="App min-h-screen bg-ink font-body text-slate-200 antialiased">
      <AnimatePresence>{!booted && <BootScreen />}</AnimatePresence>
      <Navbar onQuote={() => setQuoteOpen(true)} />
      <main>
        <Hero booted={booted} onQuote={() => setQuoteOpen(true)} />
        <Marquee />
        <Services />
        <NeedsMatrix />
        <ModularGrowth />
        <Process />
        <ClosingCta onQuote={() => setQuoteOpen(true)} />
      </main>
      <Footer onQuote={() => setQuoteOpen(true)} />
      <QuoteModal open={quoteOpen} onOpenChange={setQuoteOpen} />
      <WhatsAppButton />
    </div>
  );
}
